// Pure helpers for the B2B VAT format-audit CSV export.
// Kept in a separate module so they can be unit-tested without React.

const COLUMNS = [
  'id',
  'companyName',
  'countryCode',
  'rawVatNumber',
  'normalisedVatNumber',
  'status',
  'reason',
  'isApproved',
  'vatReversed',
  'criticalVatReversedWithoutValidVat',
  'criticalBeReverseChargeMisconfig',
  'criticalApprovedWithInvalidVat',
  'critical',
  'linkedPersonsSummary',
];

/**
 * RFC-4180 style CSV cell escape. Quotes are doubled; cells containing
 * commas, quotes, or any line break are wrapped in quotes. Null/undefined
 * become an empty cell; booleans become 'true'/'false'.
 */
export function escapeCsvCell(value) {
  if (value === null || value === undefined) return '';
  const s = typeof value === 'boolean' ? (value ? 'true' : 'false') : String(value);
  if (/[",\r\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

/** Compact "Anna J <anna@x>; Bert P <bert@x>" summary string. */
export function summariseLinkedPersons(persons) {
  if (!Array.isArray(persons) || persons.length === 0) return '';
  return persons.map(p => {
    const name = [p.firstName, p.lastName].filter(Boolean).join(' ').trim();
    const email = p.email || '';
    if (name && email) return `${name} <${email}>`;
    return name || email || p.id || '';
  }).join('; ');
}

/**
 * Build a CSV string for the given audit rows. Column order is fixed
 * (see COLUMNS). Caller is responsible for filtering rows beforehand —
 * the export respects whatever the caller passes in.
 */
export function buildAuditCsv(rows) {
  const header = COLUMNS.join(',');
  const lines = (rows || []).map(r => COLUMNS.map(col => {
    if (col === 'linkedPersonsSummary') return escapeCsvCell(summariseLinkedPersons(r.linkedPersons));
    return escapeCsvCell(r[col]);
  }).join(','));
  return [header, ...lines].join('\r\n');
}

/** UTC YYYY-MM-DD for filenames. */
export function todayStamp(date = new Date()) {
  const y = date.getUTCFullYear();
  const m = String(date.getUTCMonth() + 1).padStart(2, '0');
  const d = String(date.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function auditCsvFilename(date = new Date()) {
  return `herborist-b2b-vat-audit-${todayStamp(date)}.csv`;
}

export const __CSV_COLUMNS = COLUMNS;
